export default "__VITE_ASSET__DqSP1RLE__"